import React from 'react';
import './about.css';

export default function About(prop) {
  const about_image_path = process.env.PUBLIC_URL + '/img/about.png';

  return (
    <div className={"mainContainer"}>
      <div className={"about"}>
        <div className={'content'}>
          <img src={about_image_path} alt="about" width={'100%'} height={'100%'} />
        </div>
      </div>
    </div>
  )
}